import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getReferralActivityAPI(id: string) {
  return serviceRequest(() => Service.referralControllerGetActivities(id, true));
}
